import type { GallerySort } from "@/types/gallery";

export const DEFAULT_GALLERY_SORT: GallerySort = "featured";

export const GALLERY_SORT_OPTIONS: Array<{
  value: GallerySort;
  label: string;
}> = [
  { value: "featured", label: "Featured" },
  { value: "price-asc", label: "Price: low to high" },
  { value: "price-desc", label: "Price: high to low" },
];

export function isGallerySort(
  value: string | null | undefined
): value is GallerySort {
  return GALLERY_SORT_OPTIONS.some(option => option.value === value);
}

export function normalizeGallerySort(
  value: string | string[] | null | undefined
): GallerySort {
  const candidate = Array.isArray(value) ? value[0] : value;
  return isGallerySort(candidate) ? candidate : DEFAULT_GALLERY_SORT;
}

export function withGallerySortParam(
  href: string,
  sort: GallerySort = DEFAULT_GALLERY_SORT
): string {
  if (sort === DEFAULT_GALLERY_SORT) {
    return href;
  }

  const [pathname, search = ""] = href.split("?");
  const params = new URLSearchParams(search);
  params.set("sort", sort);
  return `${pathname}?${params.toString()}`;
}
